import React from 'react'
import './WeAreAll.css'
import Cudzyslow from '../images/svg/cudzyslow.svg'
import PawelFoto from '../images/webp/pawelfoto_edited.webp'
import BlueButton3 from './BlueButton3'

function WeAreAll() {
    return (
        <div className='we-are-all-main'>
            <div className='we-are-all-left'>
                <h3>
                    Build smarter, grow faster.
                    <br />Powered by AI.
                </h3>
                <p>
                    We design intelligent growth systems that automate marketing,<br /> 
                    content, and customer conversations — so your business<br /> scales without scaling your team.
                </p>
            </div>
            <div className='we-are-all-right-one'>
                <div className='cytat'>
                    <img src={Cudzyslow} alt='cudzysłów' className='cudzyslow-ico' />
                    <p className='cudzyslow-text'> The future of marketing isn’t more people.
It’s better systems.
                    </p>

                </div>
                <div className='the-boss'>
                    <div className='boss-foto'>
                        <img src={PawelFoto} alt='Paweł Scharmach' />

                    </div>
                    <div className='boss-text'>
                        <p>Pawel Scharmach<br />
                            <span className='blue-text'> CEO AT MARKETING V8 </span>
                        </p>
                    </div>
                </div>
                <div className='button-div'>

                    <BlueButton3
                        text='Contact us'
                    />
                </div>
            </div>


        </div >
    )
}

export default WeAreAll